import { c as _c } from "react/compiler-runtime";
import { Button as BaseButton } from '@base-ui/react';
import { cva, cx } from '@repo/pandacss/css';
import type { Ref } from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  size?: 'small' | 'medium' | 'large';
  ref?: Ref<HTMLButtonElement>;
}
const buttonRecipe = cva({
  base: {
    width: '[100%]',
    bg: 'greens.main',
    color: 'common.white',
    border: 'none',
    rounded: 'md',
    fontWeight: 'semibold',
    cursor: 'pointer',
    transition: 'all',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    _hover: {
      bg: 'greens.dark'
    },
    _active: {
      transform: '[scale(0.99)]'
    },
    _disabled: {
      bg: 'neutral.lighter-2',
      color: 'neutral.dark',
      cursor: 'not-allowed'
    }
  },
  variants: {
    size: {
      small: {
        textStyle: 'body.small',
        py: '2',
        px: '3',
        lineHeight: 'body'
      },
      medium: {
        textStyle: 'body',
        py: '3',
        px: '3.5',
        lineHeight: 'body'
      },
      large: {
        textStyle: 'body.large',
        py: '4',
        px: '4',
        lineHeight: 'body'
      }
    }
  }
});
export function Button(t0) {
  const $ = _c(16);
  let children;
  let className;
  let ref;
  let rest;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      children,
      className,
      size: t1,
      type: t2,
      ref,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = ref;
    $[4] = rest;
    $[5] = t1;
    $[6] = t2;
  } else {
    children = $[1];
    className = $[2];
    ref = $[3];
    rest = $[4];
    t1 = $[5];
    t2 = $[6];
  }
  const size = t1 === undefined ? "medium" : t1;
  const type = t2 === undefined ? "button" : t2;
  let t3;
  if ($[7] !== className || $[8] !== size) {
    t3 = cx(buttonRecipe({
      size
    }), className);
    $[7] = className;
    $[8] = size;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== children || $[11] !== ref || $[12] !== rest || $[13] !== t3 || $[14] !== type) {
    t4 = <BaseButton ref={ref} className={t3} type={type} {...rest}>{children}</BaseButton>;
    $[10] = children;
    $[11] = ref;
    $[12] = rest;
    $[13] = t3;
    $[14] = type;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}